/**
 * EMR Section ID constants
 * These IDs are used as keys in styleOverridesForPrintedEmrSections map
 */
export const EMR_SECTION_IDS = {
  HEALTH_COMPLAINTS: 'health_complaints',
  DIAGNOSIS: 'diagnosis',
  OBSERVATIONS: 'observations',
  DRUG_ADVICE: 'drug_advice',
  INVESTIGATIONS: 'investigations',
  ADVICE: 'advice',
  NEXT_VISIT_DETAILS: 'next_visit_details',
  THERAPY_RECOMMENDATION: 'therapy_recommendation',
  PAYMENT_AND_REFUND: 'payment_and_refund',
  JOINT_HOMUNCULUS: 'joint_homunculus',
  INSTRUCTIONS: 'instructions',
  PATIENT_VITALS: 'patient-vitals',
  SCREENING_REPORT: 'screening-report',
  PRIVATE_NOTES: 'private_notes',
  PSYCH_ASSESSMENTS: 'psych_assessments',
  REFER_TO: 'refer_to',
  PATIENT_HISTORY_NOTES: 'patient-history-notes',
  SCREENING_RECOMMENDATION: 'screening-recommendation',
  SIGNATURE: 'signature',
  FREE_FORM_RICH_TEXT: 'free_form_rich_text',
}

const DRUG_ADVICE_SECTION_ALIASES = new Set([
  'drugadvice',
  'drugadvicerx',
  'drug',
  'drugs',
  'medication',
  'medications',
  'medicine',
  'medicines',
  'prescription',
  'rx',
])

function normalizeEmrSectionKey(value) {
  return typeof value === 'string' ? value.replace(/[^a-z0-9]/gi, '').toLowerCase() : ''
}

export function isDrugAdviceEmrSection(sectionOrId) {
  if (!sectionOrId) return false

  if (typeof sectionOrId === 'string') {
    const normalized = normalizeEmrSectionKey(sectionOrId)
    return DRUG_ADVICE_SECTION_ALIASES.has(normalized)
  }

  return [
    sectionOrId.id,
    sectionOrId.uid,
    sectionOrId.code,
    sectionOrId.defCode,
    sectionOrId.sourceDefId,
    sectionOrId.title,
    sectionOrId.printTitle,
    sectionOrId.name,
  ].some((value) => isDrugAdviceEmrSection(value))
}

export function getCanonicalEmrSectionStyleOverrideKey(sectionOrId) {
  return isDrugAdviceEmrSection(sectionOrId) ? EMR_SECTION_IDS.DRUG_ADVICE : sectionOrId?.id || sectionOrId
}
